import RequiredFieldsChecker from "./RequiredFieldChecker";

const SegnalazioneStructure = {

    getStructure: function (segnalazioneType : string, role : string) {
        return {
            sections: [
                {
                    id: "identitaSegnalante",
                    label: "Identità segnalante",
                    number: 1,
                    subSections: [
                        {
                            name: "Persona fisica incaricata di effettuare la segnalazione",
                            id: "persFisicaSegnalante",
                            description: "Nome, cognome, recapiti telefonici e posizione occupata dalla persona fisica incaricata di trasmettere la STOR  presso il soggetto segnalante ",
                            multipleValue: false,
                            fields: [
                                {
                                    name: "nome",
                                    type: "text",
                                    numColMd: 4,
                                    max:50,
                                    label: "Nome",
                                    tooltipText: "",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante", "persFisicaSegnalante", "nome", segnalazioneType, role)
                                },
                                {
                                    name: "cognome",
                                    type: "text",
                                    numColMd: 4,
                                    max:50,
                                    tooltipText: "",
                                    label: "Cognome",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante", "persFisicaSegnalante", "cognome", segnalazioneType, role)

                                },
                                {
                                    name: "posPrezzoSegnalante",
                                    type: "text",
                                    numColMd: 4,
                                    max:100,
                                    label: "Posizione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "persFisicaSegnalante",
                                        "posPrezzoSegnalante",
                                        segnalazioneType, 
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "numeroProtocolloSegnalante",
                                    type: "text",
                                    numColMd: 4,
                                    max:30,
                                    label: "Numero di Protocollo del segnalante",
                                    required: false,
                                    tooltipText: ""
                                }
                            ]
                        },
                        {
                            name: "Dati anagrafici del soggetto segnalante",
                            id: "datiAnagraficiSegnalante",
                            multipleValue: false,
                            description: <span>Nominativo ed indirizzo  e completo del soggetto segnalante; per le persone giuridiche anche:<br/>
                                - se applicabile, forma giuridica specificata nel registro del paese a norma della cui legge la persona giuridica è costituita;<br/>
                                - se applicabile, identificativo della persona giuridica (codice LEI) secondo la norma ISO 17442 </span>,
                            fields: [
                                {
                                    name: "nomeSoggettoSegnalante",
                                    type: "text",
                                    numColMd: 4,
                                    max:120,
                                    label: "Nome soggetto segnalante",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "datiAnagraficiSegnalante",
                                        "nomeSoggettoSegnalante",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "tipoSoggettoSegnalante",
                                    type: "choice",
                                    numColMd: 4,
                                    choiceListName: "tipoSoggettoSegnalante",
                                    label: "Tipo soggetto segnalante",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "datiAnagraficiSegnalante",
                                        "tipoSoggettoSegnalante",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "formaGiuridica",
                                    type: "choice",
                                    choiceListName: "formaGiuridica",
                                    numColMd: 4,
                                    label: "Forma giuridica",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "datiAnagraficiSegnalante",
                                        "formaGiuridica",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "codiceLEI",
                                    type: "text",
                                    numColMd: 4,
                                    max:20,
                                    label: "Codice LEI",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                    "datiAnagraficiSegnalante",
                                    "codiceLEI",
                                    segnalazioneType,
                                    role),
                                    tooltipText: ""
                                },
                                {
                                    name: "via",
                                    type: "text",
                                    numColMd: 8,
                                    max:50,
                                    label: "Via/Strada/Piazza/Viale/Corso",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "datiAnagraficiSegnalante",
                                        "via",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "numCivico",
                                    type: "text",
                                    max:10,
                                    numColMd: 3,
                                    label: "N° Civico",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "datiAnagraficiSegnalante",
                                        "numCivico",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "codPostale",
                                    type: "text",
                                    numColMd: 3,
                                    max:10,
                                    label: "Codice Postale",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "datiAnagraficiSegnalante",
                                        "codPostale",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "regione",
                                    type: "text",
                                    numColMd: 3,
                                    max:200,
                                    choiceListName: "regione",
                                    label: "Città",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "datiAnagraficiSegnalante",
                                        "regione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "provincia",
                                    type: "choice",
                                    numColMd: 3,
                                    choiceListName: "provincia",
                                    label: "Provincia",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "datiAnagraficiSegnalante",
                                        "provincia",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "nazione",
                                    type: "choice",
                                    choiceListName: "nazione",
                                    numColMd: 3,
                                    label: "Nazione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "datiAnagraficiSegnalante",
                                        "nazione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                            ]
                        },
                        {
                            name: "Veste segnalante - Tipo di attività di negoziazione - Tipo di relazione con soggetto",
                            multipleValue: false,
                            id: "vesteSegnalante",
                            description: "Descrizione della veste in cui il soggetto segnalante ha agito relativamente agli ordini e operazioni che potrebbero costituire abuso di informazioni privilegiate, manipolazione di mercato ovvero tentato abuso di informazioni privilegiate o tentata manipolazione di mercato, ad esempio se ha eseguito ordini per conto di clienti, negoziato per proprio conto, gestito una sede di negoziazione o agito come internalizzatore sistematico; descrizione degli eventuali accordi o circostanze o relazioni societari, contrattuali o organizzativi ",
                            fields: [
                                {
                                    name: "vesteSegnalante",
                                    type: "choice",
                                    choiceListName: "vesteSegnalante",
                                    numColMd: 4,
                                    label: "Veste",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "vesteSegnalante",
                                        "vesteSegnalante",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "catTipologiaNegoziazione",
                                    type: "choice",
                                    choiceListName: "catTipologiaNegoziazione",
                                    numColMd: 4,
                                    label: "Tipo di attività",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "vesteSegnalante",
                                        "catTipologiaNegoziazione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "catTipologiaStrumNegoziato",
                                    type: "choice",
                                    choiceListName: "catTipologiaStrumNegoziato",
                                    numColMd: 4,
                                    label: "Tipo di strumento negoziato",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "vesteSegnalante",
                                        "catTipologiaStrumNegoziato",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "relazioneConSoggSegnalato",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Tipo di relazione con soggetto segnalato",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "vesteSegnalante",
                                        "relazioneConSoggSegnalato",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "noteTipoVeste",
                                    type: "textNote",
                                    numColMd: 4,
                                    max:255,
                                    label: "Note",
                                    required: false,
                                    tooltipText: ""
                                }
                            ]
                        },
                        {
                            name: "Referente per la richiesta di ulteriori informazioni (Salvare almeno un referente tramite il tasto Aggiungi)",
                            id: "referenteRichiestaMaggioriInfo",
                            labelForAddedValues: "Referenti aggiunti",
                            multipleValue: true,
                            multipleValueRequired: false,
                            description: "Persona di contatto presso il soggetto segnalante per la richiesta di ulteriori informazioni relative alla segnalazione (ad esempio responsabile della conformità) e relativi estremi di contatto ",
                            fields: [
                                {
                                    name: "nomeReferente",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Nome",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "referenteRichiestaMaggioriInfo",
                                        "nomeReferente",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "cognomeReferente",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Cognome",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "referenteRichiestaMaggioriInfo",
                                        "cognomeReferente",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "indirizzoMailReferente",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Indirizzo Email",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "referenteRichiestaMaggioriInfo",
                                        "indirizzoMailReferente",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "posizioneReferente",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Posizione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "referenteRichiestaMaggioriInfo",
                                        "posizioneReferente",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "numCellulare",
                                    type: "text",
                                    numColMd: 4,
                                    max:30,
                                    label: "Cellulare",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "referenteRichiestaMaggioriInfo",
                                        "numCellulare",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "numTelefono",
                                    type: "text",
                                    numColMd: 4,
                                    max:30,
                                    label: "Telefono",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaSegnalante",
                                        "referenteRichiestaMaggioriInfo",
                                        "numTelefono",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                            ]
                        }
                    ]
                },
                {
                    id: "ordineOperazione",
                    label: "Ordine/Operazione",
                    number: 2,
                    subSections: [
                        {
                            name: "Descrizione dello strumento finanziario (Salvare almeno uno strumento finanziario tramite il tasto Aggiungi)",
                            id: "descrStrumFinanziario",
                            multipleValue: true,
                            multipleValueRequired: true,
                            description: <span>Descrivere lo strumento finanziario oggetto della STOR ( se più di uno utilizzare il bottone AGGIUNGI) indicandone:<br/>
                                - nome completo o descrizione;<br/>
                                - se applicabile, codice identificativo stabilito dal regolamento delegato della commissione adottato a norma dell'articolo 26 del regolamento (UE) n. 600/2014 o altro codice;<br/>
                                - tipo secondo la tassonomia utilizzata per classificarlo e relativo codice (codice CFI secondo ISO 10962).<br/>
                                Inserire ulteriori elementi per gli ordini e le operazioni relativi a derivati OTC:<br/>
                                - identificazione del tipo di derivato OTC (ad esempio, contratto per differenza (CFD), swap, credit default swap (CDS), opzione fuori borsa (OTC) ) secondo i tipi previsti all'articolo 4, paragrafo 3, lettera b), del regolamento di esecuzione (UE) n. 1247/2012 della Commissione;<br/>
                                - descrizione delle caratteristiche del derivato OTC, tra cui almeno, se pertinenti al particolare tipo di derivato:<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • importo nominale (valore nominale);<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • valuta della denominazione del prezzo;<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • data di scadenza;<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • premio (prezzo);<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • tasso di interesse;<br/>
                                Se pertinenti al particolare tipo di derivato OTC, indicazione almeno di:<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • termini dell'operazione quali prezzo di esercizio e condizioni contrattuali (ad esempio, utile o perdita sulla spread bet per movimento di variazione);<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • margine, pagamento anticipato e dimensione o valore nominale dello strumento finanziario sottostante:<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • termini dell'operazione quali prezzo di esercizio e condizioni contrattuali (ad esempio, utile o perdita sulla spread bet per movimento di variazione);<br/>
                                - Descrizione dello strumento finanziario sottostante del derivato OTC indicandone<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • nome completo o descrizione;<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • se applicabile, codice identificativo stabilito dal regolamento delegato che la Commissione deve adottare a norma dell'articolo 26 del regolamento (UE) n. 600/2014 o altro codice;<br/>
                                &nbsp;&nbsp; &nbsp;&nbsp; • tipo secondo la tassonomia utilizzata per classificarlo e relativo codice (codice CFI secondo ISO 10962)</span>,
                            labelForAddedValues: "Descrizione strumento finanziario",
                            fields: [
                                {
                                    name: "nomeCompletoODesc",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Nome completo o descrizione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "nomeCompletoODesc",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "codiceIdentificativo",
                                    type: "text",
                                    numColMd: 4,
                                    max:50,
                                    label: "Codice identificativo",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "codiceIdentificativo",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "tipoCodiceCFI",
                                    type: "text",
                                    numColMd: 4,
                                    max:50,
                                    label: "Tipo e codice CFI",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "tipoCodiceCFI",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "tipoDerivatoOTC",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Tipo derivato OTC",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "tipoDerivatoOTC",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "importoNominale",
                                    type: "number",
                                    numColMd: 4,
                                    label: "Importo nominale",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "importoNominale",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "valutaDenominazionePrezzo",
                                    type: "choice",
                                    numColMd: 4,
                                    choiceListName: "currency",
                                    label: "Valuta della denominazione del prezzo",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "valutaDenominazionePrezzo",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "dataScadenza",
                                    type: "date",
                                    numColMd: 4,
                                    label: "Data scadenza",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "dataScadenza",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "premio",
                                    type: "number",
                                    numColMd: 4,
                                    label: "Premio (Prezzo)",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "premio",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "tassoInteresse",
                                    type: "number",
                                    numColMd: 4,
                                    label: "Tasso di interesse",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "tassoInteresse",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "margine",
                                    type: "number",
                                    numColMd: 4,
                                    label: "Margine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "margine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "pagamentoAnticipato",
                                    type: "number",
                                    numColMd: 4,
                                    label: "Pagamento anticipato",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "pagamentoAnticipato",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "dimensione",
                                    type: "text",
                                    numColMd: 4,
                                    max:50,
                                    label: "Dimensione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "dimensione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "valoreNominale",
                                    type: "number",
                                    numColMd: 4,
                                    label: "Valore nominale",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "valoreNominale",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "prezzoEsercizio",
                                    type: "number",
                                    numColMd: 4,
                                    label: "Prezzo di esercizio",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "prezzoEsercizio",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "condizioneContrattuali",
                                    type: "text",
                                    numColMd: 4,
                                    max:50,
                                    label: "Condizioni contrattuali",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "condizioneContrattuali",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "nomeCompleto",
                                    type: "text",
                                    numColMd: 4,
                                    max:50,
                                    label: "Nome completo o descrizioni sottostanti",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "nomeCompleto",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "codIdentificatoSottostante",
                                    type: "text",
                                    numColMd: 4,
                                    max:50,
                                    label: "Codice identificativo sottostante",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "codIdentificatoSottostante",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "tipoCodiceCFISottostante",
                                    type: "text",
                                    numColMd: 4,
                                    max:50,
                                    label: "Tipo codice CFI sottostante",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "tipoCodiceCFISottostante",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "nomeSedeNegoziazione",
                                    type: "text",
                                    numColMd: 4,
                                    max:50,
                                    label: "Nome sede negoziazione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "nomeSedeNegoziazione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "codiceSedeNegoziazione",
                                    type: "text",
                                    numColMd: 4,
                                    max:10,
                                    label: "Codice sede negoziazione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "codiceSedeNegoziazione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "fuoriSede",
                                    type: "choice",
                                    numColMd: 4,
                                    choiceListName: "fuoriSede",
                                    label: "Fuori sede",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrStrumFinanziario",
                                        "fuoriSede",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                }
                            ]
                        },
                        {
                            name: "Data e ora dell'ordine",
                            id: "dataOraOrdine",
                            multipleValue: true,
                            multipleValueRequired: true,
                            description: "Indicare la data e l'ora dello o degli ordini  ( utilizzare in bottone AGGIUNGI per più ordini )  selezionando dal menu a tendina l'ordine a cui fa riferimento la data inserita, eventualmente selezionare il valore 'tutti gli ordini' per impostare la stessa data su tutti gli ordini inseriti.",
                            labelForAddedValues: "Data e ora",
                            fields: [
                                {
                                    name: "dataInizio",
                                    type: "date",
                                    numColMd: 3,
                                    label: "Data inizio",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "dataOraOrdine",
                                        "dataInizio",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "oraInizio",
                                    type: "hour",
                                    numColMd: 3,
                                    label: "Ora inizio",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "dataOraOrdine",
                                        "oraInizio",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "dataFine",
                                    type: "date",
                                    numColMd: 3,
                                    label: "Data fine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "dataOraOrdine",
                                        "dataFine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "oraFine",
                                    type: "hour",
                                    numColMd: 3,
                                    label: "Ora fine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "dataOraOrdine",
                                        "oraFine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "fusoOrario",
                                    type: "choice",
                                    choiceListName: "fusoOrario",
                                    numColMd: 3,
                                    label: "Fuso orario",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "dataOraOrdine",
                                        "fusoOrario",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                }
                            ]
                        },
                        {
                            name: "Luogo (nazione)",
                            id: "nazione",
                            multipleValue: true,
                            multipleValueRequired: true,
                            labelForAddedValues: "Luogo",
                            description: <span>Indicare nome completo dello Stato e codice paese a due caratteri secondo la norma ISO 3166-1. <br/>
                                - dove è stato impartito l'ordine (se disponibile); <br/>
                                - dove l'ordine è stato eseguito <br/>
                                In presenza di più ordini utilizzare i bottone AGGIUNGI e selezionare dal menu a tendina 'ordine corrispondente</span>,
                            fields: [
                                {
                                    name: "nomeCodiceStatoDoveImpartitoOrdine",
                                    type: "choice",
                                    choiceListName: "nazione",
                                    numColMd: 4,
                                    label: "Nome e codice stato dove è stato impartito ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "nazione",
                                        "nomeCodiceStatoDoveImpartitoOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "nomeCodiceStatoDoveEseguitoOrdine",
                                    type: "multiChoice",
                                    choiceListName: "nazione",
                                    numColMd: 4,
                                    label: "Nome e codice stato dove è stato eseguito ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "nazione",
                                        "nomeCodiceStatoDoveEseguitoOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                            ]
                        },
                        {
                            name: "Descrizione dell'ordine",
                            id: "descrizioneOrdine",
                            labelForAddedValues: "Descrizione dell'ordine (max 2500 caratteri)",
                            multipleValue: true,
                            description: "Descrivere le seguenti caratteristiche dell'ordine ( per più di un ordine utilizzare il bottone AGGIUNGI)  ovvero della o delle operazioni segnalati.\n" +
                                "In presenza di vari ordini o operazioni che potrebbero costituire abuso di informazioni privilegiate, manipolazione di mercato ovvero tentato abuso\n" +
                                "di informazioni privilegiate o tentata manipolazione di mercato, è possibile trasmettere all'autorità competente i dati sui relativi prezzi e volumi in un allegato della STOR selezionando il check 'inserimento multiplo'.",
                            multipleValueRequired: true,
                            fields: [
                                {
                                    name: "numeroRiferimentoOrdine",
                                    type: "text",
                                    numColMd: 3,
                                    max:255,
                                    label: "Numero di riferimento dell'ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "numeroRiferimentoOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "dataRegolamento",
                                    type: "date",
                                    numColMd: 3,
                                    label: "Data regolamento",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "dataRegolamento",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "oraRegolamento",
                                    type: "hour",
                                    numColMd: 3,
                                    label: "Ora regolamento",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "oraRegolamento",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "prezzoAcquistoVendita",
                                    type: "number",
                                    numColMd: 4,
                                    label: "Prezzo di acquisto/vendita",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "prezzoAcquistoVendita",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "volumeQuantitaStrumentiFinanziari",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Volume/quantità di strumenti finanziari",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "volumeQuantitaStrumentiFinanziari",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "tipoOrdine",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Tipo di ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "tipoOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "modalitaInoltroOrdine",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Modalità di inoltro dell'ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "modalitaInoltroOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "oraInoltroOrdine",
                                    type: "hour",
                                    numColMd: 4,
                                    label: "Orario dell'inoltro dell'ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "oraInoltroOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "identitaPersonaCheInoltraOrdine",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Identità della persona che ha effettivamente inoltrato l'ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "identitaPersonaCheInoltraOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "identitaPersonaCheRiceveOrdine",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Identità della persona che ha effettivamente ricevuto l'ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "identitaPersonaCheRiceveOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "mezzoTrasmissioneOrdine",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Mezzo di trasmissione dell'ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "mezzoTrasmissioneOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "oraModificaCancellazione",
                                    type: "hour",
                                    numColMd: 4,
                                    label: "Orario della modifica o cancellazione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "oraModificaCancellazione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "identitaPersonaCheCancellaOrdine",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Identità della persona che ha modificato o cancellato l'ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "identitaPersonaCheCancellaOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "naturaDellaModifica",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Natura della modifica",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "naturaDellaModifica",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "mezzoPerModificaOrdine",
                                    type: "text",
                                    max:255,
                                    numColMd: 4,
                                    label: "Mezzo usato per modificare l'ordine",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("ordineOperazione",
                                        "descrizioneOrdine",
                                        "mezzoPerModificaOrdine",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "descrizioneNaturaSospetto",
                    number: 3,
                    label: "Descrizione della natura del sospetto",
                    subSections: [
                        {
                            name: "Natura del sospetto",
                            id: "naturaSospetto",
                            multipleValue: false,
                            description: <span>Indicare il tipo di violazione che potrebbero costituire gli ordini o operazioni segnalati:<br/>
                                - manipolazione del mercato,<br/>
                                - abuso di informazioni privilegiate, L 160/12 IT Gazzetta ufficiale dell'Unione europea 17.6.2016 <br/>
                                - tentata manipolazione del mercato, <br/>
                                - tentato abuso di informazioni privilegiate</span>,
                            fields: [
                                {
                                    name: "natura",
                                    type: "choice",
                                    choiceListName: "naturaSospetto",
                                    numColMd: 4,
                                    label: "Natura del sospetto",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("descrizioneNaturaSospetto",
                                        "naturaSospetto",
                                        "naturaSospetto",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                }
                            ]
                        },
                        {
                            name: "Motivi del sospetto",
                            id: "motiviSospetto",
                            multipleValue: false,
                            description: <span>Descrizione dell'attività (operazioni e ordini, modalità di inoltro degli ordini o di esecuzione delle operazioni e caratteristiche degli ordini e operazioni che li rendono sospetti) e del modo in cui la questione ha richiamato l'attenzione del segnalante e precisazione dei motivi per sospettare.<br/>
                                Criteri indicativi per redigere la descrizione (elenco non esaustivo): <br/>
                                - per gli strumenti finanziari ammessi alla negoziazione/negoziati in una
                                sede di negoziazione, descrizione della natura dell'interazione con il portafoglio ordini/delle operazioni sul portafoglio ordini che potrebbero costituire abuso di informazioni privilegiate, manipolazione di mercato ovvero
                                tentato abuso di informazioni privilegiate o tentata manipolazione di mercato; <br/>
                                - per i derivati OTC, dati relativi alle operazioni eseguite o agli ordini inoltrati sull'attività sottostante e informazioni sui possibili collegamenti tra le
                                negoziazioni dell'attività sottostante sul mercato a pronti e le negoziazioni del derivato OTC segnalate</span>,
                            fields: [
                                {
                                    name: "motiviSospetto",
                                    type: "textArea",
                                    numColMd: 12,
                                    max:2500,
                                    label: "Motivi del sospetto (max 2500 caratteri)",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("descrizioneNaturaSospetto",
                                        "motiviSospetto",
                                        "motiviSospetto",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "identitaDelSospettato",
                    label: "Identità del sospettato",
                    number: 4,
                    subSections: [
                        {
                            name: "Informazioni personali (Salvare almeno un sospettato tramite il tasto Aggiungi)",
                            id: "informazioniPersonali",
                            multipleValue: true,
                            labelForAddedValues: "Identità aggiunte",
                            multipleValueRequired: false,
                            description: "Inserire i seguenti dati che consentono di stabilire l'identità della persona ( per più persone utilizzare il bottone AGGIUNGI)  i cui ordini o operazioni potrebbero costituire abuso di informazioni privilegiate, manipolazione di mercato ovvero tentato abuso di informazioni privilegiate o tentata manipolazione di mercato (il \"sospettato\")",
                            fields: [
                                {
                                    name: "nome",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Nome / Codice Aderente",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "nome",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "cognome",
                                    type: "text",
                                    numColMd: 4,
                                     max:255,
                                    label: "Cognome / Codice Cliente",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "cognome",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "formaGiuridica",
                                    type: "choice",
                                    choiceListName: "formaGiuridica",
                                    numColMd: 4,
                                    label: "Forma giuridica",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "formaGiuridica",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "dataNascita",
                                    type: "date",
                                    numColMd: 4,
                                    label: "Data di nascita",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "dataNascita",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "numeroIdentificativoNazionale",
                                    type: "text",
                                    numColMd: 5,
                                    max:255,
                                    label: "Numero di identificativo nazionale (Codice fiscale/nazionale o codice LEI)",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "numeroIdentificativoNazionale",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "via",
                                    type: "text",
                                    numColMd: 6,
                                    max:50,
                                    label: "Via",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "via",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "numeroCivico",
                                    type: "text",
                                    numColMd: 3,
                                    max:10,
                                    label: "Numero civico",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "numeroCivico",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "codicePostale",
                                    type: "text",
                                    numColMd: 3,
                                    max:10,
                                    label: "Codice postale",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "codicePostale",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "localita",
                                    type: "text",
                                    numColMd: 4,
                                    max:200,
                                    label: "Località",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "localita",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "regione",
                                    type: "choice",
                                    choiceListName: "regione",
                                    numColMd: 4,
                                    label: "Regione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "regione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "provincia",
                                    type: "choice",
                                    choiceListName: "provincia",
                                    numColMd: 4,
                                    label: "Provincia",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "provincia",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "nazione",
                                    type: "choice",
                                    numColMd: 4,
                                    choiceListName: "nazione",
                                    label: "Nazione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "nazione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "luogo",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Luogo",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "luogo",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "posizione",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Posizione",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "posizione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "numeroConto",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Numero/numeri di conto",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "numeroConto",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "identificativoCliente",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Identificativo del cliente",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "identificativoCliente",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "relazioneConEmittenteStrumFinanziari",
                                    type: "text",
                                    numColMd: 4,
                                    max:1000,
                                    label: "Relazione con l'emittente degli strumenti finanziari",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "relazioneConEmittenteStrumFinanziari",
                                        segnalazioneType,
                                        role),
                                    tooltipText: "Inserire la relazione con l'emittente degli strumenti finanziari. Nel caso in cui non sia possibile reperire l'informazione inserire il valore 'Non noto'"
                                },
                                {
                                    name: "posizioneSospettato",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Posizione del sospettato",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "posizioneSospettato",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "naturaInterventoSospettato",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Natura dell'intervento del sospettato",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "naturaInterventoSospettato",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "entitaPortafoglioSospettato",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Entità del portafoglio del sospettato",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "entitaPortafoglioSospettato",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "dataInizioRelazioneProfessionale",
                                    type: "date",
                                    numColMd: 4,
                                    label: "Data di inizio della relazione professionale",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "dataInizioRelazioneProfessionale",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "tipoAttivitaUnitaNegozazione",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Tipo di attività dell'unità di negoziazione del sospettato",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "tipoAttivitaUnitaNegozazione",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "modelliNegoziazioneSospettato",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Modelli di negoziazione del sospettato",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "modelliNegoziazioneSospettato",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "nomeAltriSoggettiImplicati",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Nome altri soggetti implicati (max 200 caratteri)",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "nomeAltriSoggettiImplicati",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "attivitaAltriSoggettiImplicati",
                                    type: "text",
                                    numColMd: 4,
                                    max:255,
                                    label: "Attività altri soggetti implicati (max 200 caratteri)",
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("identitaDelSospettato",
                                        "informazioniPersonali",
                                        "attivitaAltriSoggettiImplicati",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "informazioniSupplementariGenerali",
                    label: "Informazioni supplementari generali",
                    number: 5,
                    subSections: [
                        {
                            name: "Informazioni supplementari",
                            id: "informazioniSupplementari",
                            multipleValue: false,
                            description: <span>Contesto o altra informazione ritenuta pertinente dal soggetto segnalante. Ad esempio:<br/>
                                — posizione del sospettato (ad esempio, cliente al dettaglio, ente);<br/>
                                — natura dell'intervento del sospettato (per proprio conto, per conto di un cliente, altro);<br/>
                                — entità del portafoglio del sospettato;<br/>
                                — se il sospettato è cliente del soggetto segnalante, data di inizio della relazione professionale;<br/>
                                — tipo di attività dell'unità di negoziazione del sospettato, se disponibile;<br/>
                                — modelli di negoziazione del sospettato; indicativamente possono risultare utili le informazioni seguenti:<br/>
                                — abitudini di negoziazione del sospettato in termini di leva finanziaria e vendita allo scoperto e frequenza d'uso;<br/>
                                — comparabilità dell'entità dell'ordine/operazione segnalato con l'entità media degli ordini presentati/delle operazioni effettuate dal sospettato negli ultimi 12 mesi;<br/>
                                — abitudini del sospettato in termini di emittenti di cui ha negoziato titoli o di tipi di strumenti finanziari negoziati<br/>
                                negli ultimi 12 mesi, in particolare indicando se l'ordine/operazione segnalato riguarda un emittente di cui il sospettato ha negoziato titoli nell'ultimo anno;<br/>
                                — altri soggetti/persone notoriamente implicati negli ordini o operazioni che potrebbero costituire abuso di informazioni privilegiate, manipolazione di mercato ovvero tentato abuso di informazioni privilegiate o tentata manipolazione di mercato:<br/>
                                — nome;<br/>
                                — attività (ad esempio esecuzione di ordini per conto di clienti, negoziazione per proprio conto, gestione di una sede di negoziazione, internalizzatore sistematico ecc.).]</span>,
                            fields: [
                                {
                                    name: "noteAggiuntive",
                                    type: "textArea",
                                    numColMd: 12,
                                    label: "Note aggiuntive (max 2500 caratteri)",
                                    max:2500,
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("informazioniSupplementariGenerali",
                                        "informazioniSupplementari",
                                        "noteAggiuntive",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                },
                                {
                                    name: "iniziativeControSoggettoSegnalato",
                                    type: "textArea",
                                    numColMd: 12,
                                    label: "Iniziative nei confronti del soggetto segnalato (max 2500 caratteri)",
                                    max:2500,
                                    required: RequiredFieldsChecker.checkIfFieldIsRequired("informazioniSupplementariGenerali",
                                        "informazioniSupplementari",
                                        "iniziativeControSoggettoSegnalato",
                                        segnalazioneType,
                                        role),
                                    tooltipText: ""
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    }

}

export default SegnalazioneStructure;
